import template from './viewObligationAttributionModal.html';
import controller from './viewObligationAttributionModal.controller';

let ViewObligationAttributionModalComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  size: 'lg',
  windowClass: 'hmodal-info animated zoomIn'
};

ViewObligationAttributionModalComponent.template = template;
ViewObligationAttributionModalComponent.controller = controller;

export default ViewObligationAttributionModalComponent;



// WEBPACK FOOTER //
// ./client/common/modals/viewObligationAttributionModal/viewObligationAttributionModal.component.js